const splitArrayIntoChunks = (array = [], chunkLength = 1) => {
  const accumulateArray = Array(Math.ceil(array.length / chunkLength)).fill([]);
  const chunks = array.reduce((acc, value, index) => {
    const accIndex = Math.floor(index / chunkLength);

    acc[accIndex] = [...acc[accIndex], value];

    return acc;
  }, accumulateArray);

  return chunks;
};

// eslint-disable-next-line no-undefined
const isNil = value => (value === null || value === undefined);

export {splitArrayIntoChunks, isNil};
